import { forwardRef } from 'react';
import { CellulaInputRatingRoot, InputRatingRootProps } from './_input_rating_root.component';

export const InputRating = {
	Root: forwardRef(CellulaInputRatingRoot),
} as const;
export type { InputRatingRootProps };
